// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rJ3B","controls":"styles_controls__3i5J9","charLimit":"styles_charLimit__3ue8S","input":"styles_input__1dMJ9","send":"styles_send__2EJmE"};